import { render, staticRenderFns } from "./EditorHeaderMobilePresentButton.vue?vue&type=template&id=37e32dbb&scoped=true&"
import script from "./EditorHeaderMobilePresentButton.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderMobilePresentButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderMobilePresentButton.vue?vue&type=style&index=0&id=37e32dbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e32dbb",
  null
  
)

export default component.exports